import { Link } from "react-router-dom";
import { STORIES } from "@/mocks/stories";
import { COLUMNS } from "@/mocks/site";

const QUOTES = [
  { name: "大四·小笼包", text: "每晚熄灯前刷一圈，甜的和虐的都有，当睡前下饭瓜刚刚好。", tag: "表白现场" },
  { name: "研二·阿宅", text: "最难得的是吃瓜的同时还总有人提醒我们别越过隐私的线，这点很拉好感。", tag: "理性吃瓜" },
  { name: "大一·晚风", text: "第一次知道谈恋爱还有这么多门道，有些『纠纷』复盘真的能学到相处分寸。", tag: "情侣纠纷" },
];

export default function ReputationBand() {
  return (
    <section>
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="overflow-hidden rounded-2xl bg-gradient-to-br from-secondary-100 via-background-100 to-accent-100/70">
          <div className="grid items-center gap-6 p-6 md:grid-cols-2 md:p-10">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-500 px-3 py-1 text-xs font-medium text-background-50">
                <i className="ri-vip-crown-line" aria-hidden="true" />
                关于大学吃瓜
              </span>
              <h2 className="mt-4 font-heading text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
                和你一起，把校园里
                <br className="hidden md:block" />
                的烟火气看个明白
              </h2>
              <p className="mt-4 text-sm leading-7 text-foreground-700 md:text-base">
                大学吃瓜是一个面向大学生的校园情感内容平台。我们不造谣、不猎奇，只把大家分享的恋爱故事、表白现场、分手与纠纷，整理成有人情味的文字，陪你度过一个个有趣的夜晚。
              </p>
              <div className="mt-6 flex flex-wrap gap-6 md:gap-10">
                {[
                  { num: `${STORIES.length * 3}+`, label: "连载故事" },
                  { num: `${COLUMNS.length}`, label: "专属栏目" },
                  { num: "每日更新", label: "滚动上新" },
                  { num: "24h", label: "陪伴在线" },
                ].map((s) => (
                  <div key={s.label} className="text-center md:text-left">
                    <div className="font-heading text-2xl font-black text-foreground-950">{s.num}</div>
                    <div className="mt-1 text-xs text-foreground-600">{s.label}</div>
                  </div>
                ))}
              </div>
              <Link
                to="/about"
                className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                深入了解我们
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </Link>
            </div>

            <div className="space-y-3">
              {QUOTES.map((q) => (
                <figure key={q.name} className="rounded-xl border border-background-200/80 bg-background-50 p-4 md:p-5">
                  <blockquote className="text-sm leading-6 text-foreground-700">「{q.text}」</blockquote>
                  <figcaption className="mt-3 flex items-center justify-between text-xs">
                    <span className="flex items-center gap-2">
                      <span className="flex h-7 w-7 items-center justify-center rounded-full bg-primary-100 text-[11px] font-bold text-primary-700">
                        {q.name.slice(-2)}
                      </span>
                      {q.name}
                    </span>
                    <span className="rounded-full bg-accent-100 px-2.5 py-1 text-accent-800">{q.tag}</span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}